<template>
    <div>
        <div  v-if="tax && taxT" class="salary-sheet-web">
            <div class="salary-sheet-title">
                <p>发工资了</p>
                <p>欢迎来 中智薪税云 查工资条</p>
            </div>
            <div class="salary-sheet-envelope">
                <div class="login-content">
                    <div class="salary-sheet-tips">
                        <p>为了保护薪资信息安全</p>
                        <p>{{isIdcard ? '请输入证件号后六位进行验证' : '请输入密码进行验证'}} </p>
                    </div>
                    <div class="salary-sheet-form">
                        <el-input v-model.trim="validCode" placeholder="请输入密码" @keyup.native.enter="handleSubmit" size="medium " class="salary-sheet-form-item" maxlength="12"></el-input>
                    </div>
                    <div class="salary-sheet-btn">
                        <el-button class="salary-sheet-btn-item" type="primary" round @click="handleSubmit">查看</el-button>
                    </div>
                    <div class="salary-sheet-date">
                        <i class="el-icon-time"></i>
                        <span>{{$route.query.time | repDate}}</span>
                    </div>
                    <div v-if="tax" class="salary-sheet-date" style="margin-top: 20px;font-size: 13px">
                        <p>版权所有：中智薪税技术服务有限公司  京公网安备 11010502042147号</p>
                        <p>京ICP备07500522号-5</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!tax" class="salary-sheet-web">
            <section class="salary-sheet-title">
                <p>发工资了</p>
                <p>欢迎来 中智薪税云 查工资条</p>
            </section>
            <section class="salary-sheet-content">
                <div class="salary-sheet-view-date">{{$route.query.time | repDate}}</div>
                <section class="salary-sheet-content-main">
                    <section class="salary-sheet-content-left">
                        <div class="highlight">
                            <div class="highlight-top">
                                <div>
                                    <img class="icon-salary" :src="iconSalary" />
                                    <span class="highlight-field">{{wagesForm.taxTypeName}}</span>
                                    <span class="highlight-unit">（元）</span>
                                </div>
                                <div>
                                    <img class="download-item" v-if="wagesForm.downLoadSetting && (['10520003','10520004'].includes(wagesForm.downLoadSetting))" @click="dowln('excel')" :src="downloadExcel" style="cursor: pointer" />
                                    <img class="download-item" v-if="wagesForm.downLoadSetting && (['10520002','10520004'].includes(wagesForm.downLoadSetting))" @click="dowln('pdf')" :src="downloadPdf" style="cursor: pointer"/>
                                </div>
                            </div>
                            <div class="highlight-main">
                                <p class="highlight-value">{{ getHighLightField.columnValue.replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g,'$1,') }}</p>
                                <p class="highlight-compare" v-if="wagesForm.isBilingual=='31240001' || wagesForm.isBilingual=='31240003'">{{ getHighLightField.itemName }}</p>
                                <p class="highlight-compare" v-if="wagesForm.isBilingual=='31240002' || wagesForm.isBilingual=='31240003'">
                                    {{ getHighLightField.itemEnName ? getHighLightField.itemEnName : (wagesForm.isBilingual=='31240002') ? getHighLightField.itemName : '' }}
                                </p>
                            </div>
                        </div>
                        <div class="highlight-divider">
                            <div class="circle"></div>
                            <div class="line"></div>
                            <div class="circle"></div>
                        </div>
                        <div class="salary-groups">
                        <div class="salary-group-item" v-for="(groupItem, groupIndex) in itemListsFilter" :key="groupItem.id">
                                <div class="salary-group-title" v-if="wagesForm.isBilingual=='31240001'">{{ groupItem.name }}</div>
                                <div class="salary-group-title" v-if="wagesForm.isBilingual=='31240002'">{{ groupItem.enName == null || groupItem.enName == '' ? groupItem.name : groupItem.enName }}</div>
                                <div class="salary-group-title" v-if="wagesForm.isBilingual=='31240003'">{{ groupItem.name + ' / ' + groupItem.enName | repNull}}</div>
                                <div class="salary-list">
                                    <div class="salary-item" v-for="(salaryItem, salaryIndex) in groupItem.payrollItemParam" :key="salaryItem.id">
                                        <div class="salary-label-value" v-if="!notClon.includes(salaryItem.payrollItemId)">
                                            <div v-if="wagesForm.isBilingual=='31240001' || wagesForm.isBilingual=='31240003'" style="width: 70%" class="salary-label">
                                                {{ salaryItem.showName ? salaryItem.showName : salaryItem.itemName }}
                                                <span v-if="wagesForm.isBilingual=='31240002' || wagesForm.isBilingual=='31240003'" >
                                                    {{ salaryItem.showEnName ? salaryItem.showEnName : salaryItem.itemEnName ? (salaryItem.showEnName ? salaryItem.showEnName : salaryItem.itemEnName) : (wagesForm.isBilingual=='31240002') ? salaryItem.itemName : '' }}
                                                </span>
                                                <svg v-if="salaryItem.remarks" @click="clickRem(salaryIndex)" class="icon" aria-hidden="true" slot="reference" style="margin-left: 3px; color: #05cfa4">
                                                    <use xlink:href="#icon-tishi"></use>
                                                </svg>
                                            </div>
                                            <div v-if="wagesForm.isBilingual=='31240002'" style="width: 70%" class="salary-label">
                                                <span>
                                                    {{ salaryItem.showEnName ? salaryItem.showEnName : salaryItem.itemEnName ? (salaryItem.showEnName ? salaryItem.showEnName : salaryItem.itemEnName) : (wagesForm.isBilingual=='31240002') ? salaryItem.itemName : '' }}
                                                </span>
                                                <svg v-if="salaryItem.remarks" @click="clickRem(salaryIndex)" class="icon" aria-hidden="true" slot="reference" style="margin-left: 3px; color: #05cfa4">
                                                    <use xlink:href="#icon-tishi"></use>
                                                </svg>
                                            </div>
                                            <div class="salary-value" style="width: 30%;text-align: right">{{ salaryItem | repValue }}</div>
                                        </div>
                                        <div class="salary-label-value" v-else>
                                            <div v-if="wagesForm.isBilingual=='31240001' || wagesForm.isBilingual=='31240003'" class="salary-label">
                                                {{ salaryItem.showName ? salaryItem.showName : salaryItem.itemName }}
                                                <span v-if="wagesForm.isBilingual=='31240002' || wagesForm.isBilingual=='31240003'" >
                                                    {{ salaryItem.showEnName ? salaryItem.showEnName : salaryItem.itemEnName ? (salaryItem.showEnName ? salaryItem.showEnName : salaryItem.itemEnName) : (wagesForm.isBilingual=='31240002') ? salaryItem.itemName : '' }}
                                                </span>
                                                <svg v-if="salaryItem.remarks" @click="clickRem(salaryIndex)" class="icon" aria-hidden="true" slot="reference" style="margin-left: 3px; color: #05cfa4">
                                                    <use xlink:href="#icon-tishi"></use>
                                                </svg>
                                            </div>
                                            <div v-if="wagesForm.isBilingual=='31240002'" class="salary-label">
                                                <span>
                                                    {{ salaryItem.showEnName ? salaryItem.showEnName : salaryItem.itemEnName ? (salaryItem.showEnName ? salaryItem.showEnName : salaryItem.itemEnName) : (wagesForm.isBilingual=='31240002') ? salaryItem.itemName : '' }}
                                                </span>
                                                <svg v-if="salaryItem.remarks" @click="clickRem(salaryIndex)" class="icon" aria-hidden="true" slot="reference" style="margin-left: 3px; color: #05cfa4">
                                                    <use xlink:href="#icon-tishi"></use>
                                                </svg>
                                            </div>
                                            <div class="salary-value">{{ salaryItem | repValue }}</div>
                                        </div>
                                        <div class="tips" v-if="salaryItem.remarks && showRemarl.includes(salaryIndex)">{{ salaryItem.remarks }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="salary-sheet-bottom pc-bottom">
                            <div class="trademark" style="font-size: 13px">
                                <p>版权所有：中智薪税技术服务有限公司  京公网安备 11010502042147号</p>
                                <p>京ICP备07500522号-5</p>
                            </div>
                        </div>
                    </section>
<!--                    <section class="miniprogram">-->
<!--                        <div class="miniprogram-code">-->
<!--                            <img class="miniprogram-code-img" :src="miniprogramCode"  />-->
<!--                            <p class="miniprogram-desc">微信扫描上方二维码，进入中智 薪税云小程序，即可微信查收最新和历史工资单。</p>-->
<!--                        </div>-->
<!--                    </section>-->
                </section>
            </section>
        </div>
    </div>

</template>

<script>
    import { getSlaryInfo, downPayrollEncl, censorPayrollReq, checkEmpInfo} from '@/api/payroll/payroll';
import iconSalary from '@/assets/img/salarySheet/icon-salary.png';
import iconQuestion from '@/assets/img/salarySheet/icon-question.png';
import downloadExcel from '@/assets/img/salarySheet/download-excel.png';
import downloadPdf from '@/assets/img/salarySheet/download-pdf.png';
import miniprogramCode from '@/assets/img/salarySheet/ewm.png';
import { downloadFile, formatFloat } from '@/util/util';
    export default {
        name: "SalarySheetLogin",
        data() {
            return {
                validCode: '',
                tax: true,
                taxT: false,
                isIdcard: false,
                itemLists: [],
                wagesForm: {},
                isSetting: true,
                feedData: {content: ''},
                visible: false,
                xuehua: '',
                randStr: '',
                tablePk: '',
                iconSalary,
                iconQuestion,
                downloadExcel,
                downloadPdf,
                miniprogramCode,
                showRemarl: [],
                notClon: ['1231871499445219329', 'CUS_ID'],
            }
        },
        created() {
            this.init()
        },
        methods: {
            clickRem(idenx){
                console.log("idenx", idenx);
                let nowArr = this.showRemarl.filter(item => item == idenx)
                if (nowArr.length > 0) {
                    this.showRemarl = this.showRemarl.filter(item => item != idenx)
                } else {
                    this.showRemarl.push(idenx);
                }
            },
            // handleSubmit() {
            //     if (!this.validCode) {
            //         this.$message.error('请输入密码进行验证');
            //         return;
            //     }
            // },
            init() {
                if (!this.$route.query.xuehua || !this.$route.query.randStr ) {
                    this.$router.push({path: '/login'})
                }
                this.xuehua = this.$route.query.xuehua;
                this.randStr = this.$route.query.randStr;
                let param = {
                    xuehua: this.xuehua,
                    randStr: this.randStr,
                }
                censorPayrollReq(param).then(res => {
                    this.taxT = res.data.data.res;
                    // console.log("this.taxT", this.taxT);
                    if (res.data.data.isSetPayrollPwd && res.data.data.isSetPayrollPwd == '10020001') {
                        this.isIdcard = true;
                    }
                    this.tablePk = res.data.data.tablePk;
                    // 校验参数
                    if (this.taxT) {

                    } else {
                        // 不正确返回登录
                        this.$router.push({path: '/login'})
                    }
                })
            },
            handleSubmit() {
                if (!this.validCode) {
                    this.$message.error('请输入内容进行验证！');
                    return;
                }
                let param = {
                    inputVal: this.validCode,
                    xuehua: this.xuehua,
                    randStr: this.randStr,
                }
                checkEmpInfo(param).then(res => {
                    if (res.data.data.tablePk) {
                        this.tax = false;
                        const query = {
                            tablePk: this.tablePk,//所选模板id
                            queueId: this.xuehua,//所选模板名称
                            time: this.$route.query.time
                        }
                        // this.$router.push({ path: '/salarySheetView', query});
                        this.initSalaryInfo();
                    } else {
                        this.$message.error('验证信息错误！请重新核对！');
                    }
                })
            },
            initSalaryInfo() {
                getSlaryInfo({tablePk: this.tablePk, queueId: this.xuehua}).then((res) => {
                    this.wagesForm = res.data.data;
                    this.itemLists = this.wagesForm.payrollSets;
                });
            },
            dowln(val) {
                downPayrollEncl({id: this.$route.query.xuehua,
                 type: val == 'excel' ? '10520003' : '10520002'}).then(res => {
                    downloadFile(res);
                })
                this.$message.success('下载中，请稍等!');
            },
        },
        computed: {
            // ...mapGetters([
            // 'dicts',
            // ]),
            itemListsFilter() {
            let itemLists = this.itemLists;
            if (!this.isSetting) {
                let arr = [];
                itemLists.forEach((emp,index) => {
                let params = {
                    ...emp,
                    payrollItemParam: []
                }
                emp.payrollItemParam.forEach((element,eleIndex) => {
                    element.columnValue = element.result;
                    let flag = element.isDisplayNull == "10020001" || (element.isDisplayNull == "10020002" && !!element.result && element.result != 0);
                    if (flag) {
                    params.payrollItemParam.push(element);
                    }
                })
                if (params.payrollItemParam.length > 0) {
                    arr.push(params);
                }
                })
                return arr;
            } else {
                let arr = [];
                itemLists.forEach((emp,index) => {
                let params = {
                    ...emp,
                    payrollItemParam: []
                }
                emp.payrollItemParam.forEach((element,eleIndex) => {
                    let flag = element.isDisplayNull == "10020002" || (element.isDisplayNull == "10020001" && !!element.columnValue && element.columnValue != 0);
                    // let flag = element.isDisplayNull == '10020002' ? (element.columnValue ? true : false) : true;
                    if (flag) {
                    params.payrollItemParam.push(element);
                    }
                })
                if (params.payrollItemParam.length > 0) {
                    arr.push(params);
                }
                })
                return arr;
            }
            },
            /**
             * 高亮显示选中值
             * 当高亮显示值为空时，展示为“-”
             * @returns {*|{}}
             */
            getHighLightField () {
            let highLightField = this.highLightFieldOptions.filter(item => {
                return item.id == this.wagesForm.highLightField
            })[0] || {};
            if (!this.isSetting) {
                highLightField.columnValue = highLightField.result;
            }
            highLightField.columnValue = highLightField.columnValue != '' && highLightField.columnValue != null && highLightField.columnValue != undefined ? highLightField.columnValue : '-';
            return highLightField;
            },
            // 高亮显示下拉框
            highLightFieldOptions () {
            let options = [];
            let itemLists = this.itemLists;
            itemLists.forEach(emp => {
                options = options.concat(emp.payrollItemParam);
            })
            return options;
            }
        },
        filters:{
            repNull(val) {
                if (val.indexOf('null')) {
                    return val.replace("null",'');
                }
            },
            repValue(val) {
            if (val.valueType == '2') {
                let xx = val.columnValue ? val.columnValue : '0.00';
                let xxx = xx.split('.');
                if (xxx.length > 1) {
                if ( xxx[1].length == 1) {
                    xx += '0';
                }
                } else if (xxx.length == 1) {
                xx += '.00'
                }
                return xx.replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g,'$1,');
            } else {
                return val.columnValue ? val.columnValue : '--';
            }
            },
            repDate(val) {
                return val.replace("-",' ');
            },
        },
    }
</script>

<style lang="scss" scoped>
.confirmBtn{
    border-radius: 20px !important;
}
.markContent {
    img{
        width: 206px;
        margin: auto;
    }
    p{
        padding: 0 20%;
        margin-top: 6%;
        line-height: 20px;
    }
}

.mobile{
    .salary-value {
        text-align: right;
        word-break:break-all
    }
    .salary-sheet-web{
        background: url("../../assets/img/ding2.png") no-repeat;
        background-size: contain;
        background-color: #E4EAF0;
        height: 100%;
        padding: 3.54% 0 0;
        box-sizing: border-box;
        // max-width: 750px;
        // min-width: 750px;
        .salary-sheet-content{
            width:auto;
            margin: 0;
            padding: 3.54% 3.28%;
            background: none;
            box-shadow:none;
        }
        .salary-sheet-title{
            display: none;
        }
        .miniprogram{
            display: none;
        }
        .salary-sheet-view-date{
            display: none;
        }
        .circle,.salary-group-item{
            padding-right: 15px;
            background-color: #E4EAF0 !important;
        }
        .salary-sheet-content-left{
            width: 100% !important;
            background-color: #fff !important;
            background: url("../../assets/img/salarySheet/detail-yellow.png") no-repeat -10px 0;
            background-size: contain;
        }
        .salary-group-item{
            background-color: #F8F8F8 !important;
        }
        .salary-groups{
            padding: 0 12px !important;
        }
        .salary-group-title{
            font-size: 14px !important;
            font-weight: bold;
        }
        .salary-list{
            padding-left: 2px !important;
        }
        .tip{
            padding: 10px;
            background: #E1E4F1;
            border-radius: 5px;
            color: #333;
            font-size: 13px;
            width: 98%;
            margin: auto;
            margin-bottom: 15px;
            .laba{
                width: 15px;
                height: 15px;
            }
            .close{
                width: 11px;
                height: 11px;
                float: right;
            }
        }
        .mobile-bottom{
            display: block;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap:wrap;
            width: auto;
            padding: 10px 10px;
            background: #fff;
            margin-top: 25px;
            img{
                width: 12.5px;
                height: 12.5px;
            }
        }
        .pc-bottom,.tips{
            // display: none;
        }
        .tip{
            display: block;
        }
        .highlight-top .download-item {
            width: 20px;
            height: 20px;
        }
        .bottom-tip{
            padding: 6px 7px;
            width: 100%;
            background-color: #FFF2ED;
            color: #FC4444;
            border-radius: 5px;
            margin-top: 7px;
        }
    }
}
</style>
